import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { formatEncodingExceptionqalxwmlsg11w as formatEncodingException } from './internal/JsonExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonDecodingExceptionClass;
function JsonDecodingException() {
  if (JsonDecodingExceptionClass === VOID) {
    class $ extends JsonException() {
      constructor(fullMessage, shortMessage, offset, path, input, hint) {
        return new.target.new_kotlinx_serialization_json_JsonDecodingException_2f7233_k$(fullMessage, shortMessage, offset, path, input, hint);
      }
      static new_kotlinx_serialization_json_JsonDecodingException_2f7233_k$(fullMessage, shortMessage, offset, path, input, hint) {
        var $this = this.new_kotlinx_serialization_json_JsonException_60qhd8_k$(fullMessage);
        captureStack($this, $this.$throwableCtor_6);
        $this.shortMessage_1 = shortMessage;
        $this.offset_1 = offset;
        $this.path_1 = path;
        $this.input_1 = input;
        $this.hint_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDecodingException');
    JsonDecodingExceptionClass = $;
  }
  return JsonDecodingExceptionClass;
}
var JsonExceptionClass;
function JsonException() {
  if (JsonExceptionClass === VOID) {
    class $ extends SerializationException() {
      static new_kotlinx_serialization_json_JsonException_60qhd8_k$(message) {
        var $this = this.new_kotlinx_serialization_SerializationException_jj1itu_k$(message);
        captureStack($this, $this.$throwableCtor_5);
        $this.message_1 = message;
        delete $this.message;
        return $this;
      }
      get_message_h23axq_k$() {
        return this.message_1;
      }
      get message() {
        return this.get_message_h23axq_k$();
      }
    }
    initMetadataForClass($, 'JsonException');
    JsonExceptionClass = $;
  }
  return JsonExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends JsonException() {
      constructor(shortMessage, classSerialName, hint) {
        return new.target.new_kotlinx_serialization_json_JsonEncodingException_uuxufm_k$(shortMessage, classSerialName, hint);
      }
      static new_kotlinx_serialization_json_JsonEncodingException_uuxufm_k$(shortMessage, classSerialName, hint) {
        classSerialName = classSerialName === VOID ? null : classSerialName;
        hint = hint === VOID ? null : hint;
        var $this = this.new_kotlinx_serialization_json_JsonException_60qhd8_k$(formatEncodingException(shortMessage, hint));
        captureStack($this, $this.$throwableCtor_6);
        $this.shortMessage_1 = shortMessage;
        $this.classSerialName_1 = classSerialName;
        $this.hint_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
//region block: exports
export {
  JsonDecodingException as JsonDecodingExceptionoyag1psadwuw,
  JsonEncodingException as JsonEncodingException3vzv9k0f9l05u,
};
//endregion

//# sourceMappingURL=JsonExceptions.mjs.map
